export default __webpack_public_path__ + "static/ai_horizontal_eng-679a799be28c131b037a252d631b3246.png";